import type { OrderSummary } from '#domain/Order.ts';

export const sortOrderOptions = (orders: OrderSummary[], selectedOrderIds: string[]) =>
    [
        ...orders.filter(order => selectedOrderIds.includes(order.id)),
        ...orders.filter(order => !selectedOrderIds.includes(order.id)),
    ].map(order => ({
        id: order.id,
        label: order.number,
        selected: selectedOrderIds.includes(order.id),
    }));
